import React, { useEffect, useState } from "react";
import Loader from "../../Components/Loader/Loader";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ServerError } from "../../Utils/ErrorMessages";
import {
  Col,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { userId } from "../../Utils/LocalStorage";
import defaultupload from "../../assets/default-upload.svg";
import defaultupload_fb from "../../assets/default-fb.png";
import iicon from "../../assets/i.svg";
import DatePicker from "react-datepicker";
import Datepickericon from "../../assets/date-picker.svg";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import SideBar from "../SideBar/SideBar";
import { getCouponData } from "../API/Coupons/CouponData";
import BackButton from "../BackButton/BackButton";
import getFormatedDate from "../../Utils/DateFormatter";
// import { ManageCouponsApi } from "../../Utils/Api/ManageCoupons";
// import { formatDate } from "../../Utils/FormatDate";

const ViewCoupon = () => {
  const [loading, setLoading] = useState(false);
  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  // const [availableDate, setAvailableDate] = useState();
  const [data, setData] = useState({});
  const { coupon_id } = useParams();
  const navigate = useNavigate();


  const getCouponDetails = async () => {
    if (!coupon_id) {
      return;
    }
    try {
      setLoading(true);
      const response = await getCouponData(coupon_id, () => {
        navigate("/");
      });
      if (response.success) {
        console.log("view-coupon",response)
        setData(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCouponDetails();
  }, []);
  return (
    <div>
      {loading ? <Loader /> : ""}{" "}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />

          <p className="page-maintitle">View Coupon</p>
          <div className="acc-dashboard mt-4">
            <div className="input_fileds">
              <Form className="formmain mx-2 mt-2 signin-row profile-form pb-4 Create-Vouch">
                <Row>
                  <Col md="6">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Business <span className="star-required">*</span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Control
                          style={{ width: "100%" }}
                          type="text"
                          value={data?.business_name}
                          className="custom-formcontrol"
                          maxLength={200}
                          name="voucher_name"
                          autoComplete="off"
                          disabled={true}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Coupon Name <span className="star-required">*</span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Control
                          style={{ width: "100%" }}
                          type="text"
                          value={data?.coupon_name}
                          className="custom-formcontrol"
                          maxLength={200}
                          name="voucher_name"
                          autoComplete="off"
                          disabled={true}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                </Row>
                {/* images */}
                <div className="d-flex gap-30 marginTop-40 mb-4 img_sec_product">
                  {/* logo */}
                  <div className="col-4 px-0 mb-2">
                    <div className="image-upload-crop">
                      <p className="uploadtextmain">
                        Coupon Image &nbsp;
                        <span className="star-required">*</span>
                        <br />
                        <span className="info_text">
                          (Recommended size 1000 x 1000)
                        </span>
                      </p>
                      <div
                        className="upload_banner_empty_logo"
                        style={{ cursor: "not-allowed" }}
                      >
                        <img
                          loading="lazy"
                          className={
                            data?.coupon_image == ""
                              ? "default-img"
                              : "product-img"
                          }
                          src={
                            data.coupon_image == ""
                              ? defaultupload
                              : data?.coupon_image
                          }
                          height="300"
                          width="300"
                          alt="coupon-img"
                        />
                      </div>
                    </div>
                  </div>
                  {/* fb */}
                  <div className="col-8 px-0">
                    <p className="uploadtextmain">
                      Social Share Image &nbsp;
                      <br />
                      <span className="info_text">
                        (Recommended size 1200px x 630px)
                      </span>
                    </p>
                    <div
                      className="upload_banner_empty_fb"
                      style={{ cursor: "not-allowed" }}
                    >
                      <img
                        className={
                          data?.coupon_social_image == ""
                            ? "default-img"
                            : "product-img"
                        }
                        loading="lazy"
                        src={
                          data?.coupon_social_image
                            ? data?.coupon_social_image
                            : defaultupload_fb
                        }
                        alt="coupon-social-img"
                      />
                    </div>
                  </div>
                </div>
                {/* limit,.. */}
                <Row className="VoucherAmountDollar marginTop-40 mb-4">
                  <Col md="6" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Coupon Code <span className="star-required">*</span>
                      </Form.Label>

                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={data?.coupon_code}
                            className="custom-formcontrol"
                            autoComplete="off"
                            disabled={true}
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="6" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Coupon Quantity <span className="star-required">*</span>
                      </Form.Label>

                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={data?.total_quantity}
                            className="custom-formcontrol"
                            autoComplete="off"
                            disabled={true}
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                {/* date,.. */}
                <Row className="VoucherAmountDollar marginTop-40 mb-4">
                  <Col md="4" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        <p className="VoucherP VLimit">
                          Coupon Publish Start Date
                          <span className="star-required">*</span>
                        </p>
                      </Form.Label>
                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={data?.coupon_start_date ? getFormatedDate(data?.coupon_start_date) : ""}
                            className="custom-formcontrol"
                            autoComplete="off"
                            disabled={true}
                          />
                          <Image
                            loading="lazy"
                            src={Datepickericon}
                            className="date-picker-icon"
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="4" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        <p className="VoucherP VValue">
                          Coupon Available Until Date
                          <span className="star-required">*</span>
                        </p>
                      </Form.Label>
                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={data?.coupon_avail_until_date ? getFormatedDate(data?.coupon_avail_until_date):""}
                            className="custom-formcontrol"
                            autoComplete="off"
                            disabled={true}
                          />
                          <Image
                            loading="lazy"
                            src={Datepickericon}
                            className="date-picker-icon"
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="4" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        <p className="VoucherP VDiscount">
                          Coupon Expiration Date
                          <span className="star-required">*</span>
                        </p>
                      </Form.Label>
                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={data?.coupon_end_date ? getFormatedDate(data?.coupon_end_date) : ""}
                            className="custom-formcontrol"
                            autoComplete="off"
                            disabled={true}
                          />

                          <Image
                            loading="lazy"
                            src={Datepickericon}
                            className="date-picker-icon"
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                {/* description */}
                <Row className="desc_terms_condition create_Voucher_Desc_Row mb-4 marginTop-40">
                  <Col md="12" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom info-sec">
                        Coupon Description{" "}
                        <span className="star-required">*</span>{" "}
                      </Form.Label>
                      <FroalaEditorView model={data?.coupon_description} />
                    </Form.Group>
                  </Col>
                </Row>
                {/* t&c */}
                <Row className="desc_terms_condition marginTop-40">
                  <Col md="12" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Terms & Conditions
                        <span className="star-required">*</span>
                      </Form.Label>
                      <Form.Group
                        className="mb-3 ack fr-view"
                        controlId="formBasicCheckbox"
                        disabled={true}
                      >
                        {data?.coupon_term_condition
                          ? data?.coupon_term_condition.map((item,index) => {
                              return (
                                <ul key={index}>
                                  <li>{item}</li>
                                </ul>
                              );
                            })
                          : " "}
                      </Form.Group>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </div>
  );
};

export default ViewCoupon;
